/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-direct-mutation-state */
import React, { Component } from "react";

import {
  ActionTypeMap,
  BookingStatus,
  DateRangeOptionsOld,
  FreightMode,
  WebNoteType,
  titlePrefix,
  TransportPath,
  UserRole,
  UserType,
  BookingTypes,
} from "@assets/constants";
import {
  Booking,
  UserProfileViewModel,
  BookingFilters,
  Label,
  BookingAction,
  Action,
  DropdownOption,
} from "@assets/types";
import {
  ArrayUtilities,
  BookingUtilities,
  DateUtilities,
  UserUtilities,
  WindowUtilities,
} from "@assets/utilities";
import Accordion from "@components/Accordion/accordion";
import ActionBar from "@components/ActionBar/actionBar";
import IconButton from "@components/Button/iconButton";
import CustomIcon from "@components/CustomIcon/customIcon";
import Icon from "@components/CustomIcon/Icons";
import DropdownSearch from "@components/Dropdown/dropdownSearch";
import Checkbox from "@components/Input/checkbox";
import stylesDatePicker from "@components/Input/reactDateOverrides.module.less";
import LabelList, { onAdd, onRemove } from "@components/Label/labelList";
import ListFilterLayout from "@components/Layout/listFilterLayout";
import ListLine from "@components/ListLine/listLine";
import ListLineItem from "@components/ListLineItem/listLineItem";
import SwitchCompanyModal from "@components/Modal/switchCompanyModal";
import WebNoteModal from "@components/Modal/webNoteModal";
import Search from "@components/Search/search";
import Select, { SelectItemProps } from "@components/Select/select";
import Tooltip from "@components/Tooltip/tooltip";
import { CheckForm } from "@samskip/frontend-components";
import BookingService from "@services/BookingService";
import SingleBookingService from "@services/SingleBookingService";
import UserService from "@services/UserService";
import {
  fetchBookingList,
  fetchBookingListFrontEnd,
  getFavoriteBookings,
  getBookingsInExcel,
  changePolOptions,
  changeConsigneeOptions,
  changePodOptions,
  changeShipperOptions,
  updateWebSetting,
  changeShippingTypeOptions,
} from "@state/actions/index";
import { AppState } from "@state/reducers/types";
import i18next from "i18next";
import { toUpper } from "lodash";
import * as _ from "lodash";
import moment from "moment";
import { DateRangePicker, FocusedInputShape, isInclusivelyBeforeDay } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import VirtualScroll from "react-dynamic-virtual-scroll";
import { Translation } from "react-i18next";
import { FiX, FiDownload } from "react-icons/fi";
import { connect } from "react-redux";
import { nameof } from "ts-simple-nameof";

import stylesShipments from "./shipments.module.less";

type ShipmentPageProps = {
  fetchBookingList: Function;
  fetchBookingListFrontEnd: Function;
  getFavoriteBookings: Function;
  changeShippingTypeOptions: Function;
  changePolOptions: Function;
  changePodOptions: Function;
  changeShipperOptions: Function;
  changeConsigneeOptions: Function;
  getBookingsInExcel: Function;
  updateWebSetting: Function;
  userProfile: UserProfileViewModel;
  bookings: Booking[];
  bookingsAll: Booking[];
  shippingTypeOptions: DropdownOption[];
  displayedShippingTypeOptions: DropdownOption[];
  polOptions: DropdownOption[];
  displayedPolOptions: DropdownOption[];
  displayedPodOptions: DropdownOption[];
  displayedConsigneeOptions: DropdownOption[];
  displayedShipperOptions: DropdownOption[];
  podOptions: DropdownOption[];
  shipperOptions: DropdownOption[];
  consigneeOptions: DropdownOption[];
  isFetchingExcelBookings: boolean;
  favoriteBookings: string[];
  loadingBookingsInit: boolean;
  loadingBookings: boolean;
};

type ShipmentPageState = {
  mobileFilter: boolean;
  filters: BookingFilters;
  labels: Label[];
  labelShippingType: Label[];
  labelPols: Label[];
  labelPods: Label[];
  labelShippers: Label[];
  labelConsignees: Label[];
  sortOptions: SelectItemProps[];
  dateRangeOptions: SelectItemProps[];
  selectedDateRangeOption: string;
  tableHeaders: string[];
  focusedInput: FocusedInputShape | null;
  shouldFilterFavorites: boolean;
  displayedItems: number;
  minItemHeight: number;
  shouldShowFreightModeFilter: boolean;
  memoModal: { open: boolean; type: number; jobReference: string };
  switchCompanyModal: { open: boolean; booking: Booking | null };
  selectedBookings: string[];
  actionMenuJobRef: string;
  loadingSwitchCompany: boolean;
};

class Shipments extends Component<ShipmentPageProps, ShipmentPageState> {
  InitialFilters = {
    searchString: "",
    searchTypes: [],
    partnerCode: this.props.userProfile.SelectedCompany.PartnerCode,
    freightModes: [],
    shippingType: [],
    startDate: moment().subtract(2, "weeks"),
    endDate: moment().add(2, "weeks"),
    POL: [],
    POD: [],
    labelsPods: [],
    shippers: [],
    consignees: [],
    isCustomsCleared: undefined,
    statuses: [],
    transportPaths: [],
    bookingTypes: [],
    sort: {
      sortBy: nameof<Booking>((item) => item.ETA),
      isDesc: false,
    },
    shouldShowFreightModeFilter: true,
  };

  state: ShipmentPageState = {
    sortOptions: [
      {
        value: nameof<Booking>((item) => item.JobReference),
        translationId: "LABEL_JOB_REFERENCE",
        text: "",
      },
      {
        value: nameof<Booking>((item) => item.Shipper),
        translationId: "LABEL_SHIPPER",
        text: "",
      },
      {
        value: nameof<Booking>((item) => item.Consignee),
        translationId: "LABEL_CONSIGNEE",
        text: "",
      },
      {
        value: nameof<Booking>((item) => item.Status),
        translationId: "LABEL_A_STATUS",
        text: "",
      },
      {
        value: nameof<Booking>((item) => item.ShippingType),
        translationId: "LABEL_SHIPPING_TYPE",
        text: "",
      },
      {
        value: nameof<Booking>((item) => item.VoyageReference),
        translationId: "LABEL_VOYAGE_REFERENCE",
        text: "",
      },
      {
        value: nameof<Booking>((item) => item.ETA),
        translationId: "LABEL_ETA",
        text: "",
      },
      {
        value: nameof<Booking>((item) => item.ETD),
        translationId: "LABEL_ETD",
        text: "",
      },
    ],
    dateRangeOptions: [
      {
        value: DateRangeOptionsOld.NEXT_MONTH,
        translationId: `LABEL_${DateRangeOptionsOld.NEXT_MONTH}`,
        text: "",
      },
      {
        value: DateRangeOptionsOld.NEXT_TWO_WEEKS,
        translationId: `LABEL_${DateRangeOptionsOld.NEXT_TWO_WEEKS}`,
        text: "",
      },
      {
        value: DateRangeOptionsOld.LAST_WEEK,
        translationId: `LABEL_${DateRangeOptionsOld.LAST_WEEK}`,
        text: "",
      },
      {
        value: DateRangeOptionsOld.LAST_TWO_WEEKS,
        translationId: `LABEL_${DateRangeOptionsOld.LAST_TWO_WEEKS}`,
        text: "",
      },
      {
        value: DateRangeOptionsOld.LAST_MONTH,
        translationId: `LABEL_${DateRangeOptionsOld.LAST_MONTH}`,
        text: "",
      },
      {
        value: DateRangeOptionsOld.LAST_THREE_MONTHS,
        translationId: `LABEL_${DateRangeOptionsOld.LAST_THREE_MONTHS}`,
        text: "",
      },
      {
        value: DateRangeOptionsOld.LAST_YEAR,
        translationId: `LABEL_${DateRangeOptionsOld.LAST_YEAR}`,
        text: "",
      },
      {
        value: DateRangeOptionsOld.CUSTOM_DATE,
        translationId: `LABEL_${DateRangeOptionsOld.CUSTOM_DATE}`,
        text: "",
      },
    ],
    selectedDateRangeOption: DateRangeOptionsOld.CUSTOM_DATE,
    mobileFilter: false,
    filters: _.cloneDeep(this.InitialFilters),
    labels: [],
    tableHeaders: [
      "TEXT_DESCRIPTION",
      "TEXT_WEIGHT",
      "TEXT_VOLUME",
      "TEXT_QUANTITY",
      "TEXT_TEMP_CONTROL",
    ],
    focusedInput: null,
    shouldFilterFavorites: false,
    displayedItems: 12,
    minItemHeight: 95,
    labelShippingType: [],
    labelPols: [],
    labelPods: [],
    labelConsignees: [],
    labelShippers: [],
    shouldShowFreightModeFilter: this.InitialFilters.shouldShowFreightModeFilter,
    memoModal: { open: false, type: WebNoteType.EXTERNAL, jobReference: "" },
    switchCompanyModal: { open: false, booking: null },
    selectedBookings: [],
    actionMenuJobRef: "",
    loadingSwitchCompany: false,
  };

  addLabelShippingType = (label: Label) => {
    const labels = this.state.labelShippingType;
    labels.push(label);
    this.setState({
      labelShippingType: labels,
    });
  };

  addLabelPol = (label: Label) => {
    const labels = this.state.labelPols;
    labels.push(label);
    this.setState({
      labelPols: labels,
    });
  };

  addLabelShipper = (label: Label) => {
    const labels = this.state.labelShippers;
    labels.push(label);
    this.setState({
      labelShippers: labels,
    });
  };

  addLabelConsignee = (label: Label) => {
    const labels = this.state.labelConsignees;
    labels.push(label);
    this.setState({
      labelConsignees: labels,
    });
  };

  addLabelPod = (label: Label) => {
    const labels = this.state.labelPods;
    labels.push(label);
    this.setState({
      labelPods: labels,
    });
  };

  removeLabelShippingType = (key: string) => {
    this.setState({
      labelShippingType: this.state.labelShippingType.filter((label) => label.key !== key),
    });
  };

  removeLabelPol = (key: string) => {
    this.setState({
      labelPols: this.state.labelPols.filter((label) => label.key !== key),
    });
  };

  removeLabelPod = (key: string) => {
    this.setState({
      labelPods: this.state.labelPods.filter((label) => label.key !== key),
    });
  };

  removeLabelShipper = (key: string) => {
    this.setState({
      labelShippers: this.state.labelShippers.filter((label) => label.key !== key),
    });
  };

  removeLabelConsignee = (key: string) => {
    this.setState({
      labelConsignees: this.state.labelConsignees.filter((label) => label.key !== key),
    });
  };

  renderYearOptions = () => {
    const optionsArray = [];
    for (let x = 0; x < 5; x++) {
      optionsArray[x] = <option value={moment().year() - x + 1}>{moment().year() - x + 1}</option>;
    }
    return optionsArray;
  };

  scrollTop() {
    if (this.props.bookings.length > 0)
      document.getElementsByClassName("List")[0].scrollTop -= 999999;
  }

  async componentDidMount() {
    const filterWebSettings = this.props.userProfile.WebSettings.filter(
      (websetting) => websetting.Field === "ShipmentListPage"
    )[0];
    if (filterWebSettings) {
      const WebSettingsFilters: {
        startDate: string;
        endDate: string;
        filterBySelectedCompany?: boolean;
      } = JSON.parse(filterWebSettings.StringValue);
      const filters = this.state.filters;
      filters.startDate = WebSettingsFilters.startDate
        ? moment(WebSettingsFilters.startDate)
        : this.InitialFilters.startDate;
      filters.endDate = WebSettingsFilters.endDate
        ? moment(WebSettingsFilters.endDate)
        : this.InitialFilters.endDate;
      filters.partnerCode =
        WebSettingsFilters.filterBySelectedCompany === false ? "" : this.InitialFilters.partnerCode;
    }

    // Triggers recalculation for virtual scroll on a resize event.
    window.addEventListener("resize", this.updateDimensions);
    this.virtualScrollPropsCalc(window.innerWidth);

    document.title = titlePrefix + i18next.t("MENU_TRACE_BOOKINGS");
    await this.props.fetchBookingList(this.state.filters);
    this.props.getFavoriteBookings();

    this.setState({
      shouldShowFreightModeFilter: UserUtilities.userHasAccessToRoles(this.props.userProfile, [
        UserRole.SHIP,
        UserRole.AIR,
      ]),
    });
  }

  async componentDidUpdate(prevProps: { userProfile?: UserProfileViewModel }) {
    if (
      prevProps.userProfile &&
      this.props.userProfile.SelectedCompany.PartnerCode !==
        prevProps.userProfile.SelectedCompany.PartnerCode
    ) {
      if (this.state.filters.partnerCode) {
        this.onFilter(
          nameof<BookingFilters>((item) => item.partnerCode),
          i18next.t("LABEL_COMPANY"),
          this.props.userProfile.SelectedCompany.PartnerCode,
          true
        );
      }
    }
  }

  /** Fixes calculation for virtual scroll based on a resize event */
  virtualScrollPropsCalc(width: number) {
    if (width > 767) {
      this.setState({ minItemHeight: 95 });
      this.setState({ displayedItems: 12 });
    } else {
      this.setState({ minItemHeight: 218 });
      this.setState({ displayedItems: 6 });
    }
  }

  updateDimensions = () => {
    this.virtualScrollPropsCalc(window.innerWidth);
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  /** END */

  onFilter = async (
    key: string,
    text: string,
    value: string | Date | boolean | string[] | object | moment.Moment | undefined | null,
    update = false,
    serverSide = true
  ) => {
    this.scrollTop();

    this.state.filters[key] = value;

    this.setState(
      {
        filters: this.state.filters,
      },
      async () => {
        this.setState({
          labels: onAdd(this.state.labels, this.state.filters[key], key, text),
        });
        update && serverSide
          ? await this.props.fetchBookingList(this.state.filters)
          : !serverSide
          ? await this.props.fetchBookingListFrontEnd(this.state.filters, this.props.bookingsAll)
          : null;
      }
    );
  };

  onLabelRemove = (key: string) => {
    this.setState(
      {
        labels: onRemove(this.state.labels, key),
      },
      () => {
        if (
          [
            nameof<BookingFilters>((item) => item.freightModes),
            nameof<BookingFilters>((item) => item.transportPaths),
            nameof<BookingFilters>((item) => item.statuses),
            nameof<BookingFilters>((item) => item.isCustomsCleared),
            nameof<BookingFilters>((item) => item.isHazardous),
            nameof<BookingFilters>((item) => item.bookingTypes),
          ].includes(key.toString())
        ) {
          this.onFilter(key, "", this.InitialFilters[key], true, false);
        } else if (key.toString() == nameof<BookingFilters>((item) => item.POL)) {
          this.onFilter(key, "", this.InitialFilters[key], true, false);
          this.onFilter(
            nameof<BookingFilters>((item) => item.POL),
            "",
            [],
            true,
            false
          );
          this.props.changePolOptions(this.props.polOptions, []);
          this.setState({ labelPols: [] });
        } else if (key.toString() === nameof<BookingFilters>((item) => item.shippingType)) {
          this.onFilter(key, "", this.InitialFilters[key], true, false);
          this.onFilter(
            nameof<BookingFilters>((item) => item.shippingType),
            "",
            [],
            true,
            false
          );
          this.setState({ labelShippingType: [] });
        } else if (key.toString() == nameof<BookingFilters>((item) => item.POD)) {
          this.onFilter(key, "", this.InitialFilters[key], true, false);
          this.onFilter(
            nameof<BookingFilters>((item) => item.POD),
            "",
            [],
            true,
            false
          );
          this.props.changePodOptions(this.props.podOptions, []);
          this.setState({ labelPods: [] });
        } else if (key.toString() == nameof<BookingFilters>((item) => item.shippers)) {
          this.onFilter(key, "", this.InitialFilters[key], true, false);
          this.onFilter(
            nameof<BookingFilters>((item) => item.shippers),
            "",
            [],
            true,
            false
          );
          this.props.changePolOptions(this.props.shipperOptions, []);
          this.setState({ labelShippers: [] });
        } else if (key.toString() == nameof<BookingFilters>((item) => item.consignees)) {
          this.onFilter(key, "", this.InitialFilters[key], true, false);
          this.onFilter(
            nameof<BookingFilters>((item) => item.consignees),
            "",
            [],
            true,
            false
          );
          this.props.changePolOptions(this.props.consigneeOptions, []);
          this.setState({ labelConsignees: [] });
        } else if (key.toString() == nameof<BookingFilters>((item) => item.searchString)) {
          const _filter = this.state.filters;
          _filter.searchTypes = [];
          this.setState({ filters: _filter });
          this.onFilter(key, "", this.InitialFilters[key], true);
        } else if (key.toString() == nameof<BookingFilters>((item) => item.endDate)) {
          this.handleDateRangeSelect(DateRangeOptionsOld.INIT);
          this.setState({
            selectedDateRangeOption: DateRangeOptionsOld.CUSTOM_DATE,
          });
        } else {
          this.onFilter(key, "", this.InitialFilters[key], true);
        }
      }
    );
  };

  handleDateRangeSelect(value: string) {
    switch (value) {
      case DateRangeOptionsOld.INIT:
        return this.setState({ selectedDateRangeOption: DateRangeOptionsOld.INIT }, () =>
          this.handleDateChange(moment().subtract(2, "weeks"), moment().add(2, "weeks"))
        );
      case DateRangeOptionsOld.NEXT_MONTH:
        return this.setState({ selectedDateRangeOption: DateRangeOptionsOld.NEXT_MONTH }, () =>
          this.handleDateChange(moment(), moment().add(1, "months"))
        );
      case DateRangeOptionsOld.NEXT_TWO_WEEKS:
        return this.setState({ selectedDateRangeOption: DateRangeOptionsOld.NEXT_TWO_WEEKS }, () =>
          this.handleDateChange(moment(), moment().add(2, "weeks"))
        );
      case DateRangeOptionsOld.LAST_WEEK:
        return this.setState({ selectedDateRangeOption: DateRangeOptionsOld.LAST_WEEK }, () =>
          this.handleDateChange(moment().subtract(1, "weeks"), moment())
        );
      case DateRangeOptionsOld.LAST_TWO_WEEKS:
        return this.setState({ selectedDateRangeOption: DateRangeOptionsOld.LAST_TWO_WEEKS }, () =>
          this.handleDateChange(moment().subtract(2, "weeks"), moment())
        );
      case DateRangeOptionsOld.LAST_MONTH:
        return this.setState({ selectedDateRangeOption: DateRangeOptionsOld.LAST_MONTH }, () =>
          this.handleDateChange(moment().subtract(1, "months"), moment())
        );
      case DateRangeOptionsOld.LAST_THREE_MONTHS:
        return this.setState(
          { selectedDateRangeOption: DateRangeOptionsOld.LAST_THREE_MONTHS },
          () => this.handleDateChange(moment().subtract(3, "months"), moment())
        );
      case DateRangeOptionsOld.LAST_YEAR:
        return this.setState({ selectedDateRangeOption: DateRangeOptionsOld.LAST_YEAR }, () =>
          this.handleDateChange(moment().subtract(1, "years"), moment())
        );
      case DateRangeOptionsOld.CUSTOM_DATE:
        return this.setState({
          selectedDateRangeOption: DateRangeOptionsOld.CUSTOM_DATE,
        });
      default:
        return;
    }
  }

  handleDateChange = (
    startDate: moment.Moment | null,
    endDate: moment.Moment | null,
    filterTitle: string = i18next.t("LABEL_DATE_RANGE"),
    shouldRender = true,
    revertToCustom = false
  ) => {
    if (revertToCustom) {
      this.setState({
        selectedDateRangeOption: DateRangeOptionsOld.CUSTOM_DATE,
      });
    }
    if (endDate != this.state.filters.endDate || shouldRender) {
      startDate
        ? this.onFilter(
            nameof<BookingFilters>((item) => item.startDate),
            filterTitle,
            startDate
          )
        : null;
      endDate
        ? this.onFilter(
            nameof<BookingFilters>((item) => item.endDate),
            filterTitle,
            endDate,
            true
          )
        : null;

      if (startDate && endDate) {
        this.updateWebSettings();
      }
    }

    const _filters = this.state.filters;
    _filters.startDate = startDate;
    _filters.endDate = endDate;
    this.setState({ filters: _filters });
  };

  updateWebSettings = () => {
    const { startDate, endDate, partnerCode } = this.state.filters;
    if (!startDate || !endDate) return;
    const difference = moment.duration(endDate.diff(startDate));
    if (difference.asMonths() <= 12) {
      this.props.updateWebSetting({
        UserID: this.props.userProfile.Access.UserID,
        Field: "ShipmentListPage",
        Site: null,
        StringValue: JSON.stringify({
          startDate: startDate,
          endDate: endDate,
          filterBySelectedCompany: partnerCode ? true : false,
        }),
        SubSys: 1049,
      });
    }
  };

  openMemoModal = (memoType: number, jobReference: string) => {
    const memoModal: { open: boolean; type: number; jobReference: string } = {
      open: true,
      type: memoType,
      jobReference,
    };
    this.setState({ memoModal });
  };

  closeMemoModal = () => {
    const memoModal = this.state.memoModal;
    memoModal.open = false;
    this.setState({ memoModal });
  };

  openSwitchCompanyModal = (booking: Booking) => {
    const switchCompanyModal: { open: boolean; booking: Booking } = {
      open: true,
      booking: booking,
    };
    this.setState({ switchCompanyModal });
  };

  closeSwitchCompanyModal = () => {
    const switchCompanyModal = this.state.switchCompanyModal;
    switchCompanyModal.open = false;
    this.setState({ switchCompanyModal });
  };

  openActionMenu = (jobReference: string) => {
    let actionMenuJobRef = this.state.actionMenuJobRef;
    actionMenuJobRef = jobReference;
    this.setState({ actionMenuJobRef });
  };

  closeActionMenu = () => {
    const actionMenuJobRef = "";
    this.setState({ actionMenuJobRef });
  };

  selectedBookingsHaveCleared = (listCleared: boolean) => {
    const bookings = this.state.selectedBookings;
    const customsNotCleared = [];
    const customsCleared = [];

    for (let i = 0; i < bookings.length; i++) {
      const temp = this.props.bookings.find((booking) => booking.JobReference === bookings[i]);
      if (temp?.IsCustomsCleared === false) {
        customsNotCleared.push(temp.JobReference);
      } else {
        customsCleared.push(temp?.JobReference);
      }
    }
    if (listCleared === true) {
      return customsCleared;
    } else {
      return customsNotCleared;
    }
  };

  openBillOfLadingDocument = async (jobReference: string) => {
    try {
      const result = await SingleBookingService.getBookingDocuments(jobReference);

      for (const item of result) {
        if ((item.Document_Code === "HBL" || item.Document_Code === "HAWB") && item.Document_Path) {
          window.open("http://" + item.Document_Path);
        }
      }
    } catch (error) {
      console.error("Error retrieving bill of lading document", error);
    }
  };

  handleSwitchCompany = async (booking: Booking | null, partnerCode: string) => {
    this.setState({ loadingSwitchCompany: true });
    UserService.changeUserCompany(partnerCode)
      .then(() => {
        WindowUtilities.openTabOrWindow(
          `/shipments/${
            booking?.FreightMode === FreightMode.AI
              ? "copycreateairfreightbooking"
              : "copycreateseafreightbooking"
          }/${booking?.JobReference}`
        );
      })
      .finally(() => {
        this.setState({ loadingSwitchCompany: false });
        this.closeSwitchCompanyModal();
        window.location.reload();
      });
  };

  getActionOptions = async (booking: Booking): Promise<Action[]> => {
    return await BookingService.getBookingActions(
      booking.JobReference,
      booking.Status,
      booking.IsCustomsCleared
    ).then((results: BookingAction[]) => {
      return results.map((result) => {
        if ([ActionTypeMap.WEBNOTE, ActionTypeMap.INNERWEBNOTE].includes(result.TypeMap)) {
          return {
            ID: result.TypeID,
            Link: "",
            onClick: () =>
              this.openMemoModal(
                result.TypeMap === ActionTypeMap.WEBNOTE
                  ? WebNoteType.EXTERNAL
                  : WebNoteType.INTERNAL,
                booking.JobReference
              ),
            OpenInWindow: true,
            Translation: `LABEL_ACTION_${result.TypeMap}`,
            Section: result.Section,
          };
        }

        if (result.TypeMap === ActionTypeMap.BILLOFLADING) {
          return {
            ID: result.TypeID,
            Link: "",
            onClick: () => this.openBillOfLadingDocument(booking.JobReference),
            OpenInWindow: true,
            Translation: `LABEL_ACTION_${result.TypeMap}`,
            Section: result.Section,
          };
        }

        if (result.TypeMap === ActionTypeMap.ALLDOCS) {
          return {
            ID: result.TypeID,
            Link: "",
            onClick: () =>
              WindowUtilities.openTabOrWindow(
                `/singleBooking/${booking.FreightMode}/${booking.JobReference}#Documents`
              ),
            OpenInWindow: true,
            Translation: `LABEL_ACTION_${result.TypeMap}`,
            Section: result.Section,
          };
        }
        if (result.TypeMap === ActionTypeMap.INVOICES) {
          return {
            ID: result.TypeID,
            Link: "",
            onClick: () =>
              WindowUtilities.openTabOrWindow(
                `/singleBooking/${booking.FreightMode}/${booking.JobReference}#Invoices`
              ),
            OpenInWindow: true,
            Translation: `LABEL_ACTION_${result.TypeMap}`,
            Section: result.Section,
          };
        }
        if (result.TypeMap === ActionTypeMap.COPYBOOKING) {
          return {
            ID: result.TypeID,
            Link: "",
            onClick: () => {
              if (
                booking.Consignee.PartnerCode ===
                  this.props.userProfile.SelectedCompany.PartnerCode ||
                booking.Shipper.PartnerCode === this.props.userProfile.SelectedCompany.PartnerCode
              ) {
                WindowUtilities.openTabOrWindow(
                  `/shipments/${
                    booking.FreightMode === FreightMode.AI
                      ? "copycreateairfreightbooking"
                      : "copycreateseafreightbooking"
                  }/${booking.JobReference}`
                );
              } else {
                this.openSwitchCompanyModal(booking);
              }
            },
            OpenInWindow: true,
            Translation: `LABEL_ACTION_${result.TypeMap}`,
            Section: result.Section,
          };
        }
        return {
          ID: result.TypeID,
          Link:
            result.Site +
            booking.JobReference +
            (result.TypeMap === ActionTypeMap.ALLDOCS
              ? `&Partner=${booking.Consignee.PartnerCode}`
              : ""),
          OpenInWindow: true,
          Translation: `LABEL_ACTION_${result.TypeMap}`,
          Section: result.Section,
        };
      });
    });
  };

  getShippingType(shippingType: string) {
    const shippingTypes = shippingType.split(" ");
    const collection = shippingTypes[0] === "L" ? "LCL" : "FCL";
    const delivery = shippingTypes[1] === "L" ? "LCL" : "FCL";
    return collection + " - " + delivery;
  }

  render() {
    const { userProfile } = this.props;
    let { bookings } = this.props;
    const {
      filters,
      labels,
      sortOptions,
      dateRangeOptions,
      tableHeaders,
      shouldFilterFavorites,
      memoModal,
      switchCompanyModal,
      actionMenuJobRef,
    } = this.state;
    if (shouldFilterFavorites) {
      bookings = bookings.filter((booking) =>
        this.props.favoriteBookings.includes(booking.JobReference)
      );
    }

    return (
      <Translation>
        {(t) => (
          <main className="overflow-hidden static h-auto w-full mx-auto flex content-center flex-grow flex-col">
            <SwitchCompanyModal
              booking={switchCompanyModal.booking}
              closeModal={() => this.closeSwitchCompanyModal()}
              consignee={switchCompanyModal.booking?.Consignee}
              loadingSwitchCompany={this.state.loadingSwitchCompany}
              onSwitchCompany={this.handleSwitchCompany}
              open={switchCompanyModal.open}
              shipper={switchCompanyModal.booking?.Shipper}
              userSelectedCompany={userProfile.SelectedCompany}
            />
            <WebNoteModal
              closeIcon
              closeModal={() => this.closeMemoModal()}
              closeOnOutsideClick
              isNote={false}
              jobReference={memoModal.jobReference}
              open={memoModal.open}
              type={memoModal.type}
            />
            <ListFilterLayout showFilterSearchButtons>
              <>
                <div className="listFilterLayout__content relative w-auto lg:w-full flex-1 p-5">
                  {this.props.loadingBookings ? <span className="list-loader" /> : null}

                  <div className="listFilterLayout__content__header border-b flex justify-between md:block mr-5 border-jonar-orange">
                    <div className="listFilterLayout__content__header__upper flex justify-between">
                      <div>
                        <Icon
                          className="inline-block h-8 w-auto mr-2 stroke-current"
                          name="jonarArrow"
                        />
                        <h1 className="inline-block text-1xl font-bold text-jonar-blue uppercase leading-7 align-bottom">
                          {t("LABEL_TRACE")}
                        </h1>
                        <span className="text-base-icon pl-4 ml-6 md:ml-auto">
                          {this.props.loadingBookingsInit
                            ? `${bookings.length} ${t("TEXT_SHIPMENTS_FOUND", {
                                count: bookings.length,
                              })}`
                            : null}
                        </span>
                      </div>
                      <div>
                        <IconButton
                          active={this.props.isFetchingExcelBookings}
                          className="mb-5 ml-5 md:mb-auto xl:m-auto"
                          disabled={false}
                          onClick={() => this.props.getBookingsInExcel(this.props.bookings)}
                        >
                          <FiDownload className="text-base mr-2" />
                          <span className="pt-1">{t("LABEL_EXCEL")}</span>
                        </IconButton>
                      </div>
                    </div>
                    <div className="listFilterLayout__content__header__lower pr-3 lg:pr-0 cursor-pointer flex justify-between items-center mb-1 py-2">
                      <div className="hidden md:block">
                        <div className="flex items-center">
                          <span className="inline-block pt-1">{t("LABEL_SORT_BY")}</span>
                          <Select
                            className="text-sm mx-2 w-border pt-4px pb-2px"
                            isDesc={filters.sort.isDesc}
                            name="sortBy"
                            onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                              this.onFilter(
                                nameof<BookingFilters>((item) => item.sort),
                                "",
                                {
                                  sortBy: event.target.value,
                                  isDesc: filters.sort.isDesc,
                                },
                                true,
                                false
                              )
                            }
                            onSortClick={() =>
                              this.onFilter(
                                nameof<BookingFilters>((item) => item.sort),
                                "",
                                {
                                  sortBy: filters.sort.sortBy,
                                  isDesc: !filters.sort.isDesc,
                                },
                                true,
                                false
                              )
                            }
                            options={sortOptions}
                            sortDirection
                            value={this.state.filters.sort.sortBy}
                          />
                          {labels.length > 0 ? (
                            <LabelList
                              className="ml-6"
                              labelList={labels}
                              onClick={this.onLabelRemove}
                            />
                          ) : null}
                        </div>
                      </div>
                      <div>
                        <div className="flex-row flex-1 flex flex-wrap justify-end leading-none">
                          <div>
                            <CustomIcon
                              className={`svg-jonar-blue svg-lg svg-dark translate-y-4 transform translate-x-3 sm:-translate-y-2 sm:-translate-x-2 md:mr-0 md:-translate-x-2 lg:translate-x-0 lg:-m-auto${
                                this.state.shouldFilterFavorites ? "svg-fill-jonar-blue" : ""
                              }`}
                              iconName="waitsCustoms"
                              onClick={() => {
                                document.getElementsByClassName("List")[0].scrollTop -= 999999;
                                this.setState({
                                  shouldFilterFavorites: !shouldFilterFavorites,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="listFilterLayout__content__list">
                    {bookings.length > 0 ? (
                      <VirtualScroll
                        buffer={4}
                        className="List"
                        length={this.state.displayedItems}
                        minItemHeight={this.state.minItemHeight}
                        renderItem={(i: number) => {
                          return (
                            <ListLine
                              actionMenuJobRef={actionMenuJobRef}
                              checkBoxChecked={this.state.selectedBookings.includes(
                                bookings[i].JobReference
                              )}
                              closeActionMenu={this.closeActionMenu}
                              getActionOptions={() => this.getActionOptions(bookings[i])}
                              isBuyersConsoleBooking={bookings[i].IsBCBooking}
                              key={bookings[i].JobReference}
                              onCheckboxCheck={() =>
                                this.setState({
                                  selectedBookings: ArrayUtilities.toggleValueInArray(
                                    this.state.selectedBookings,
                                    bookings[i].JobReference
                                  ),
                                })
                              }
                              openActionMenu={this.openActionMenu}
                              reference={bookings[i].JobReference}
                              showInfo={
                                userProfile.Access.UserType === UserType.EMPLOYEE
                                  ? bookings[i].InternalNoteCount + bookings[i].ExternalNoteCount >
                                    0
                                  : bookings[i].ExternalNoteCount > 0
                              }
                              tableHeaders={tableHeaders}
                            >
                              <ListLineItem
                                actionLink={`/singleBooking/${bookings[i].FreightMode}/${bookings[i].JobReference}`}
                                className="w-2/5 md:w-auto md:flex-2"
                                icon={BookingUtilities.getBookingFreightModeIcon(
                                  bookings[i].FreightMode === FreightMode.AI
                                    ? FreightMode.AI
                                    : FreightMode.SH
                                )}
                                iconClasses="svg-dark"
                                mainTitle={bookings[i].JobReference}
                                preTitle={t("LABEL_BOOKING_REF")}
                                secondLine={
                                  <span>
                                    {this.getShippingType(bookings[i].ShippingType)}
                                    {bookings[i].FreightMode == FreightMode.SH &&
                                    bookings[i].IsBOL ? (
                                      <>
                                        <span>, </span>
                                        <span className="font-bold text-red-700">BOL</span>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                }
                                secondLineTitle={t("LABEL_TYPE")}
                                target="_blank"
                              />
                              <ListLineItem
                                className="w-2/5 md:w-auto md:flex-1-half"
                                icon={BookingUtilities.getStatusIcon(
                                  bookings[i].Status,
                                  bookings[i].FreightMode === FreightMode.AI
                                    ? FreightMode.AI
                                    : FreightMode.SH
                                )}
                                iconClasses={`${
                                  [
                                    BookingStatus.DELIVERED,
                                    BookingStatus.DELIVERED_EXPORT,
                                    BookingStatus.DELIVERED_POD,
                                    BookingStatus.DELIVERED_TO_DOMESTIC_TRANSPORT,
                                    BookingStatus.DELIVERED_TO_WAREHOUSE,
                                    BookingStatus.PICKED_UP_BY_CUSTOMER,
                                  ].includes(bookings[i].Status)
                                    ? "stroke-current text-green-800"
                                    : "svg-dark"
                                }`}
                                mainTitle={i18next.t(
                                  "BOOKINGSTATUS_" +
                                    (bookings[i].Status
                                      ? BookingStatus[bookings[i].Status]
                                      : "BOOKED")
                                )}
                                preTitle={t("LABEL_STATUS")}
                                secondLine={moment(bookings[i].ETA).format("DD.MM.yyyy")}
                                secondLineTitle="ETA"
                              />
                              <ListLineItem
                                className="flex-1 hidden xl:block"
                                mainTitle={bookings[i].VoyageReference || ""}
                                preTitle={t("LABEL_VOYAGE")}
                                secondLine={bookings[i].ConsignmentNumberSimplified}
                              />
                              <ListLineItem
                                className="w-2/5 md:w-auto md:flex-2 pt-5 md:pt-0"
                                mainTitle={bookings[i].Shipper.Name}
                                preTitle={t("LABEL_A_SHIPPER")}
                                secondLine={bookings[i].Shipper.PartnerCode}
                              />
                              <ListLineItem
                                className="w-2/5 md:w-auto md:flex-2 pt-5 md:pt-0"
                                mainTitle={bookings[i].Consignee.Name}
                                preTitle={t("LABEL_A_CONSIGNEE")}
                                secondLine={bookings[i].Consignee.PartnerCode}
                              />
                              <div className="flex md:flex-row-reverse mt-2 md:mt-0 md:justify-start justify-around md:w-1/6 w-full">
                                <div className="flex-nowrap w-1/3 md:w-small-item md:pr-6 text-center">
                                  {bookings[i].IsCustomsCleared ? (
                                    <Tooltip
                                      childClassName="inline-flex"
                                      content={`${t(
                                        "LABEL_CUSTOMSCLEARED"
                                      )}: ${DateUtilities.toDateString(
                                        bookings[i].CustomsClearedDate
                                      )}`}
                                    >
                                      <div>
                                        <CustomIcon
                                          className="mx-auto svg-lg inline-block md:block stroke-current text-green-800"
                                          iconName="customsDuty"
                                        />
                                      </div>
                                    </Tooltip>
                                  ) : (
                                    <CustomIcon
                                      className="mx-auto svg-lg inline-block md:block stroke-current text-red-800"
                                      iconName="dutyFree"
                                    />
                                  )}
                                  <span className="flex justify-center text-xs md:inline-block leading-none">
                                    {bookings[i].IsCustomsCleared ? (
                                      <>{t("LABEL_CUSTOMSCLEARED")}</>
                                    ) : (
                                      <>{t("LABEL_NOT_CUSTOMSCLEARED")}</>
                                    )}
                                  </span>
                                </div>
                                {bookings[i].IsBCBooking ||
                                (bookings[i].ShipReference !== null &&
                                  bookings[i].ShipReference !== "") ? (
                                  <>
                                    {bookings[i].IsBCBooking ? (
                                      <div className="flex-nowrap w-1/3 md:w-small-item md:pt-px md:pr-6 text-center">
                                        <div>
                                          <CustomIcon
                                            className="mx-auto svg-lg md:block inline-block"
                                            iconName="gripHorizontal"
                                          />
                                        </div>
                                        <span className="flex text-xs md:inline-block leading-none md:pt-1.5">
                                          {t("LABEL_BUYERS_CONSOL")}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="flex-nowrap w-1/3 md:w-small-item md:pt-px md:pr-6 text-center">
                                        <CustomIcon
                                          className="mx-auto svg-lg md:block inline-block"
                                          iconName="diagramNested"
                                        />
                                        <span className="flex text-xs md:inline-block leading-none md:pt-1.5">
                                          {t("LABEL_BUYERS_CONSOL_SUB")}
                                        </span>
                                      </div>
                                    )}
                                  </>
                                ) : null}
                              </div>
                            </ListLine>
                          );
                        }}
                        totalLength={bookings.length}
                      />
                    ) : this.props.loadingBookings ? null : (
                      <div className="text-base-icon text-3xl text-center m-20 md:m-60 select-none opacity-50">
                        {t("WARNING_NO_DATA_FOUND")}
                      </div>
                    )}
                  </div>
                </div>
                <div
                  // TODO: This makes sure that the virtual scroll works as should. Possibly we can fix this more elegantly later.
                  className={`listFilterLayout__filter lg:flex-initial bg-lighter-gray p-5 absolute xl:relative z-20 right-0 hidden xl:block ${
                    this.state.mobileFilter
                      ? "showFilter animate-fade-in min-h-full h-auto xl:h-auto"
                      : ""
                  }`}
                  id="dpFilterPanel"
                  onFocus={() => this.scrollTop()}
                >
                  <button
                    className="absolute transition duration-300 top-4r inline-block xl:hidden right-5r bg-lighter-gray border border-current text-jonar-blue hover:bg-jonar-blue hover:text-white p-1"
                    onClick={() => this.setState({ mobileFilter: false })}
                    type="button"
                  >
                    <FiX className="text-xl" />
                  </button>
                  <h2 className="text-lg font-bold text-jonar-blue uppercase leading-7">
                    {t("LABEL_FILTER_SEARCH")}
                  </h2>
                  <div className="flex justify-between md:hidden pt-2">
                    <div>
                      <span>Raða eftir</span>
                      <Select
                        className="text-sm ml-2"
                        isDesc={filters.sort.isDesc}
                        name="sortBy"
                        onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                          this.onFilter(
                            nameof<BookingFilters>((item) => item.sort),
                            "",
                            {
                              sortBy: event.target.value,
                              isDesc: filters.sort.isDesc,
                            },
                            true
                          )
                        }
                        onSortClick={() =>
                          this.onFilter(
                            nameof<BookingFilters>((item) => item.sort),
                            "",
                            {
                              sortBy: filters.sort.sortBy,
                              isDesc: !filters.sort.isDesc,
                            },
                            true
                          )
                        }
                        options={sortOptions}
                        sortDirection
                      />
                    </div>
                    <div>
                      <IconButton
                        active={this.props.isFetchingExcelBookings}
                        className="excel-button-mobile"
                        disabled={false}
                        onClick={() => this.props.getBookingsInExcel(this.props.bookings)}
                      >
                        <FiDownload className="text-base mr-2" />
                        <span className="pt-1">Excel</span>
                      </IconButton>
                    </div>
                  </div>
                  <div className="sm:block md:hidden pt-4">
                    <LabelList className="" labelList={labels} onClick={this.onLabelRemove} />
                  </div>
                  <Accordion accTitle={t("LABEL_SEARCH")} hasInfo openAccordion>
                    <Checkbox
                      checked={filters.searchTypes.includes(
                        nameof<Booking>((item) => item.JobReference)
                      )}
                      className="pb-1"
                      hasTooltip
                      label={t("LABEL_BOOKING_REFERENCE")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.searchTypes),
                          "",
                          ArrayUtilities.toggleValueInArray(
                            filters.searchTypes,
                            nameof<Booking>((item) => item.JobReference)
                          ),
                          this.state.filters.searchString.length > 0 ? true : false
                        );
                      }}
                      tooltipContent={t("INFO_BOOKING_REFERENCE")}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.searchTypes.includes(
                        nameof<Booking>((item) => item.VoyageReference)
                      )}
                      className="pb-1"
                      hasTooltip
                      label={t("LABEL_VOYAGE_REFERENCE")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.searchTypes),
                          "",
                          ArrayUtilities.toggleValueInArray(
                            filters.searchTypes,
                            nameof<Booking>((item) => item.VoyageReference)
                          ),
                          this.state.filters.searchString.length > 0 ? true : false
                        );
                      }}
                      tooltipContent={t("INFO_VOYAGE_REFERENCE")}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.searchTypes.includes(
                        nameof<Booking>((item) => item.BOLNumber)
                      )}
                      className="pb-1"
                      hasTooltip
                      label={t("LABEL_BOL_NUMBER")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.searchTypes),
                          "",
                          ArrayUtilities.toggleValueInArray(
                            filters.searchTypes,
                            nameof<Booking>((item) => item.BOLNumber)
                          ),
                          this.state.filters.searchString.length > 0 ? true : false
                        );
                      }}
                      tooltipContent={t("INFO_BOL_NUMBER")}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.searchTypes.includes(
                        nameof<Booking>((item) => item.ConsignmentNumber)
                      )}
                      className="pb-1"
                      hasTooltip
                      label={t("LABEL_CONSIGNMENT_NUMBER")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.searchTypes),
                          "",
                          ArrayUtilities.toggleValueInArray(
                            filters.searchTypes,
                            nameof<Booking>((item) => item.ConsignmentNumber)
                          ),
                          this.state.filters.searchString.length > 0 ? true : false
                        );
                      }}
                      tooltipContent={t("INFO_CONSIGNMENT_NUMBER")}
                      type="checkbox"
                    />
                    <Search
                      className="w-border mt-2 h-8"
                      icon="search"
                      isSearching={this.props.loadingBookings}
                      onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.searchString),
                          t("LABEL_SEARCH"),
                          event.target.value,
                          true
                        );
                      }}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.searchString),
                          t("LABEL_SEARCH"),
                          event.target.value,
                          false
                        )
                      }
                      onKeyPress={(event: React.KeyboardEvent) => {
                        if (event.key === "Enter") {
                          this.onFilter(
                            nameof<BookingFilters>((item) => item.searchString),
                            t("LABEL_SEARCH"),
                            this.state.filters.searchString,
                            true
                          );
                        }
                      }}
                      onSearch={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.searchString),
                          t("LABEL_SEARCH"),
                          this.state.filters.searchString,
                          true
                        );
                      }}
                      value={this.state.filters.searchString}
                    />
                  </Accordion>
                  <Accordion accTitle={t("LABEL_DATE_RANGE")} openAccordion>
                    <div className="datePickerContainerFilter flex border border-base rounded h-30px">
                      <div
                        className={`w-3/5 bg-white border-transparent focus:border-transparent focus:ring-0 ${stylesDatePicker.dateRangePickerOver}`}
                      >
                        <DateRangePicker
                          displayFormat="DD.MM.YYYY"
                          endDate={this.state.filters.endDate}
                          endDateId="timePeriodEndDate"
                          focusedInput={this.state.focusedInput}
                          isOutsideRange={(day) =>
                            !isInclusivelyBeforeDay(day, moment().add(1, "years"))
                          }
                          noBorder
                          numberOfMonths={1}
                          onDatesChange={({ startDate, endDate }) =>
                            this.handleDateChange(
                              startDate,
                              endDate,
                              t("LABEL_DATE_RANGE"),
                              false,
                              true
                            )
                          }
                          onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                          renderMonthElement={({ month, onMonthSelect, onYearSelect }) => (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <div>
                                <select
                                  className="border-transparent focus:border-transparent focus:ring-0"
                                  onChange={(e) => {
                                    onMonthSelect(month, e.target.value);
                                  }}
                                  value={month.month()}
                                >
                                  {moment.months().map((label, value) => (
                                    <option key={value} value={value}>
                                      {t("LABEL_MONTH_" + toUpper(label))}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div style={{ marginLeft: "10px" }}>
                                <select
                                  className="border-transparent focus:border-transparent focus:ring-0"
                                  onChange={(e) => {
                                    onYearSelect(month, e.target.value);
                                  }}
                                  value={month.year()}
                                >
                                  {this.renderYearOptions()}
                                </select>
                              </div>
                            </div>
                          )}
                          startDate={this.state.filters.startDate}
                          startDateId="timePeriodStartDate"
                        />
                      </div>
                      <div className="w-2/5">
                        <Select
                          className={`w-full text-sm rounded-none date-range-selector ${stylesShipments.dateRangeSelector}`}
                          name="sortBy"
                          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                            this.handleDateRangeSelect(event.target.value)
                          }
                          options={dateRangeOptions}
                          sortDirection={false}
                          value={this.state.selectedDateRangeOption}
                        />
                      </div>
                    </div>
                  </Accordion>
                  <Accordion accTitle={t("LABEL_COMPANY")} openAccordion>
                    <Checkbox
                      checked={filters.partnerCode === userProfile.SelectedCompany.PartnerCode}
                      className="pb-1"
                      label={t("LABEL_CHOSEN_COMPANY")}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.partnerCode),
                          t("LABEL_COMPANY"),
                          event.target.value,
                          true
                        );
                        this.updateWebSettings();
                      }}
                      type="radio"
                      value={userProfile.SelectedCompany.PartnerCode}
                    />
                    <Checkbox
                      checked={filters.partnerCode !== userProfile.SelectedCompany.PartnerCode}
                      className="pb-1"
                      label={
                        userProfile.Access.UserType === UserType.EMPLOYEE
                          ? t("LABEL_ALL_COMPANIES")
                          : t("LABEL_MY_COMPANIES")
                      }
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.partnerCode),
                          t("LABEL_COMPANY"),
                          event.target.value,
                          true
                        );
                        this.updateWebSettings();
                      }}
                      type="radio"
                      value=""
                    />
                  </Accordion>
                  <Accordion accTitle={t("LABEL_BOOKING_TYPE")} openAccordion>
                    <Checkbox
                      checked={filters.bookingTypes.includes(BookingTypes.NORMAL)}
                      className="pb-1"
                      label={t("LABEL_REGULAR_BOOKING")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.bookingTypes),
                          t("LABEL_BOOKING_TYPE"),
                          ArrayUtilities.toggleValueInArray(
                            filters.bookingTypes,
                            BookingTypes.NORMAL
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.bookingTypes.includes(BookingTypes.BUYERSCONSOL)}
                      className="pb-1"
                      label={t("LABEL_BUYERS_CONSOL")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.bookingTypes),
                          t("LABEL_BOOKING_TYPE"),
                          ArrayUtilities.toggleValueInArray(
                            filters.bookingTypes,
                            BookingTypes.BUYERSCONSOL
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.bookingTypes.includes(BookingTypes.SUBBOOKING)}
                      className="pb-1"
                      label={t("LABEL_BUYERS_CONSOL_SUB")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.bookingTypes),
                          t("LABEL_BOOKING_TYPE"),
                          ArrayUtilities.toggleValueInArray(
                            filters.bookingTypes,
                            BookingTypes.SUBBOOKING
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                  </Accordion>
                  <Accordion accTitle={t("LABEL_BOOKING_STATUS")} openAccordion>
                    <CheckForm
                      checked={filters.statuses.length >= 1}
                      id="shipments-filter-status-select-all"
                      indeterminate={filters.statuses.length > 0 && filters.statuses.length < 21}
                      label={t("LABEL_SELECT_ALL")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(filters.statuses, [
                            BookingStatus.BOOKED,
                            BookingStatus.COLLECTED,
                            BookingStatus.PICKUP_SCHEDULED,
                            BookingStatus.PICKUP_REGISTERED,
                            BookingStatus.IN_TRANSIT,
                            BookingStatus.DISCHARGED,
                            BookingStatus.SHIPMENT_UNLOADED,
                            BookingStatus.IN_WAREHOUSE_RECEPTION,
                            BookingStatus.ARRIVED_IN_POD,
                            BookingStatus.BEING_PICKED_AT_WAREHOUSE,
                            BookingStatus.READY_FOR_DELIVERY,
                            BookingStatus.LOADED_ON_TRUCK,
                            BookingStatus.LOAD_ON_BOARD,
                            BookingStatus.DELIVERY_BOOKED,
                            BookingStatus.OUT_FOR_DELIVERY,
                            BookingStatus.DELIVERED,
                            BookingStatus.DELIVERED_POD,
                            BookingStatus.DELIVERED_TO_DOMESTIC_TRANSPORT,
                            BookingStatus.DELIVERED_TO_WAREHOUSE,
                            BookingStatus.PICKED_UP_BY_CUSTOMER,
                            BookingStatus.DELIVERED_EXPORT,
                          ]),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.includes(BookingStatus.BOOKED)}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_BOOKED")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(filters.statuses, BookingStatus.BOOKED),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.some((s) =>
                        [
                          BookingStatus.COLLECTED,
                          BookingStatus.PICKUP_SCHEDULED,
                          BookingStatus.PICKUP_REGISTERED,
                        ].includes(s)
                      )}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_COLLECTED")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(filters.statuses, [
                            BookingStatus.COLLECTED,
                            BookingStatus.PICKUP_SCHEDULED,
                            BookingStatus.PICKUP_REGISTERED,
                          ]),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.includes(BookingStatus.IN_WAREHOUSE_RECEPTION)}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_IN_WAREHOUSE_RECEPTION")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(
                            filters.statuses,
                            BookingStatus.IN_WAREHOUSE_RECEPTION
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.includes(BookingStatus.LOAD_ON_BOARD)}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_LOAD_ON_BOARD")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(
                            filters.statuses,
                            BookingStatus.LOAD_ON_BOARD
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.includes(BookingStatus.IN_TRANSIT)}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_IN_TRANSIT")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(
                            filters.statuses,
                            BookingStatus.IN_TRANSIT
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.includes(BookingStatus.ARRIVED_IN_POD)}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_ARRIVED_IN_POD")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(
                            filters.statuses,
                            BookingStatus.ARRIVED_IN_POD
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.some((s) =>
                        [BookingStatus.DISCHARGED, BookingStatus.SHIPMENT_UNLOADED].includes(s)
                      )}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_DISCHARGED")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(filters.statuses, [
                            BookingStatus.DISCHARGED,
                            BookingStatus.SHIPMENT_UNLOADED,
                          ]),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.includes(BookingStatus.BEING_PICKED_AT_WAREHOUSE)}
                      label={t("BOOKINGSTATUS_BEING_PICKED_AT_WAREHOUSE")}
                      name="company"
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(
                            filters.statuses,
                            BookingStatus.BEING_PICKED_AT_WAREHOUSE
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                      value="company-3"
                    />
                    <Checkbox
                      checked={filters.statuses.includes(BookingStatus.READY_FOR_DELIVERY)}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_READY_FOR_DELIVERY")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(
                            filters.statuses,
                            BookingStatus.READY_FOR_DELIVERY
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.includes(BookingStatus.DELIVERY_BOOKED)}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_DELIVERY_BOOKED")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(
                            filters.statuses,
                            BookingStatus.DELIVERY_BOOKED
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.includes(BookingStatus.LOADED_ON_TRUCK)}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_LOADED_ON_TRUCK")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(
                            filters.statuses,
                            BookingStatus.LOADED_ON_TRUCK
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.includes(BookingStatus.OUT_FOR_DELIVERY)}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_OUT_FOR_DELIVERY")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(
                            filters.statuses,
                            BookingStatus.OUT_FOR_DELIVERY
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.statuses.some((s) =>
                        [
                          BookingStatus.DELIVERED,
                          BookingStatus.DELIVERED_POD,
                          BookingStatus.DELIVERED_TO_DOMESTIC_TRANSPORT,
                          BookingStatus.DELIVERED_TO_WAREHOUSE,
                          BookingStatus.PICKED_UP_BY_CUSTOMER,
                          BookingStatus.DELIVERED_EXPORT,
                        ].includes(s)
                      )}
                      className="pb-1"
                      label={t("BOOKINGSTATUS_DELIVERED")}
                      name="company"
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.statuses),
                          t("LABEL_BOOKING_STATUS"),
                          ArrayUtilities.toggleValueInArray(filters.statuses, [
                            BookingStatus.DELIVERED,
                            BookingStatus.DELIVERED_POD,
                            BookingStatus.DELIVERED_TO_DOMESTIC_TRANSPORT,
                            BookingStatus.DELIVERED_TO_WAREHOUSE,
                            BookingStatus.PICKED_UP_BY_CUSTOMER,
                            BookingStatus.DELIVERED_EXPORT,
                          ]),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                      value="company-1"
                    />
                  </Accordion>
                  <Accordion accTitle={t("LABEL_SHIPPING_TYPE")} openAccordion={false}>
                    <DropdownSearch
                      className="w-full h-f p-0"
                      containerClassName="float-left width-full contents h-12"
                      hasSearch
                      labelClassName="sm-light-tag block float-left mb-1"
                      labels={this.state.labelShippingType}
                      multiSelect
                      onLabelRemove={(value: string) => {
                        this.removeLabelShippingType(value);

                        const selectedshippingTypes = ArrayUtilities.removeValueFromArray(
                          filters.shippingType,
                          value
                        );

                        this.props.changeShippingTypeOptions(
                          this.props.shippingTypeOptions,
                          selectedshippingTypes
                        );

                        this.onFilter(
                          nameof<BookingFilters>((item) => item.shippingType),
                          t("LABEL_SHIPPING_TYPE"),
                          selectedshippingTypes.length > 0 ? selectedshippingTypes : null,
                          true,
                          false
                        );
                      }}
                      onSelect={(value: string) => {
                        const text = this.props.shippingTypeOptions.find(
                          (x) => x.value === value
                        )?.item;

                        this.addLabelShippingType({ text: text, key: value });

                        if (!filters.shippingType) {
                          filters.shippingType = [];
                        }
                        const selectedshippingTypes = ArrayUtilities.addValueToArray(
                          filters.shippingType,
                          value
                        );

                        this.props.changeShippingTypeOptions(
                          this.props.shippingTypeOptions,
                          selectedshippingTypes
                        );

                        this.onFilter(
                          nameof<BookingFilters>((item) => item.shippingType),
                          t("LABEL_SHIPPING_TYPE"),
                          selectedshippingTypes,
                          true,
                          false
                        );
                      }}
                      options={this.props.displayedShippingTypeOptions}
                    />
                  </Accordion>
                  <Accordion accTitle={t("LABEL_POL")} openAccordion={false}>
                    <DropdownSearch
                      className="w-full standard-input"
                      containerClassName="float-left width-full contents"
                      hasSearch
                      labelClassName="sm-light-tag block float-left mb-1"
                      labels={this.state.labelPols}
                      multiSelect
                      onLabelRemove={(value: string) => {
                        this.removeLabelPol(value);

                        const selectedPols = ArrayUtilities.removeValueFromArray(
                          filters.POL,
                          value
                        );

                        this.props.changePolOptions(this.props.polOptions, selectedPols);

                        this.onFilter(
                          nameof<BookingFilters>((item) => item.POL),
                          t("LABEL_POL"),
                          selectedPols.length > 0 ? selectedPols : null,
                          true,
                          false
                        );
                      }}
                      onSelect={(value: string) => {
                        const text = this.props.polOptions.find((x) => x.value == value)?.item;

                        this.addLabelPol({ text: text, key: value });

                        if (!filters.POL) {
                          filters.POL = [];
                        }
                        const selectedPols = ArrayUtilities.addValueToArray(filters.POL, value);

                        this.props.changePolOptions(this.props.polOptions, selectedPols);

                        this.onFilter(
                          nameof<BookingFilters>((item) => item.POL),
                          t("LABEL_POL"),
                          selectedPols,
                          true,
                          false
                        );
                      }}
                      options={this.props.displayedPolOptions}
                    />
                  </Accordion>
                  <Accordion accTitle={t("LABEL_POD")} openAccordion={false}>
                    <DropdownSearch
                      className="w-full standard-input"
                      containerClassName="float-left width-full contents"
                      hasSearch
                      labelClassName="sm-light-tag block float-left mb-1"
                      labels={this.state.labelPods}
                      multiSelect
                      onLabelRemove={(value: string) => {
                        this.removeLabelPod(value);

                        const selectedPods = ArrayUtilities.removeValueFromArray(
                          filters.POD,
                          value
                        );

                        this.props.changePodOptions(this.props.podOptions, selectedPods);

                        this.onFilter(
                          nameof<BookingFilters>((item) => item.POD),
                          t("LABEL_POD"),
                          selectedPods.length > 0 ? selectedPods : null,
                          true,
                          false
                        );
                      }}
                      onSelect={(value: string) => {
                        const text = this.props.podOptions.find((x) => x.value == value)?.item;

                        this.addLabelPod({ text: text, key: value });

                        if (!filters.POD) {
                          filters.POD = [];
                        }
                        const selectedPods = ArrayUtilities.addValueToArray(filters.POD, value);

                        this.props.changePodOptions(this.props.podOptions, selectedPods);

                        this.onFilter(
                          nameof<BookingFilters>((item) => item.POD),
                          t("LABEL_POD"),
                          selectedPods,
                          true,
                          false
                        );
                      }}
                      options={this.props.displayedPodOptions}
                    />
                  </Accordion>
                  <Accordion accTitle={t("LABEL_SHIPPER")} openAccordion={false}>
                    <DropdownSearch
                      className="w-full standard-input"
                      containerClassName="float-left width-full contents"
                      hasSearch
                      labelClassName="sm-light-tag block float-left mb-1"
                      labels={this.state.labelShippers}
                      multiSelect
                      onLabelRemove={(value: string) => {
                        this.removeLabelShipper(value);

                        const selectedShippers = ArrayUtilities.removeValueFromArray(
                          filters.shippers,
                          value
                        );

                        this.props.changeShipperOptions(
                          this.props.shipperOptions,
                          selectedShippers
                        );

                        this.onFilter(
                          nameof<BookingFilters>((item) => item.shippers),
                          t("LABEL_SHIPPER"),
                          selectedShippers.length > 0 ? selectedShippers : null,
                          true,
                          false
                        );
                      }}
                      onSelect={(value: string) => {
                        const text = this.props.shipperOptions.find((x) => x.value == value)?.item;

                        this.addLabelShipper({ text: text, key: value });

                        if (!filters.shippers) {
                          filters.shippers = [];
                        }
                        const selectedShippers = ArrayUtilities.addValueToArray(
                          filters.shippers,
                          value
                        );

                        this.props.changeShipperOptions(
                          this.props.shipperOptions,
                          selectedShippers
                        );

                        this.onFilter(
                          nameof<BookingFilters>((item) => item.shippers),
                          t("LABEL_SHIPPER"),
                          selectedShippers,
                          true,
                          false
                        );
                      }}
                      options={this.props.displayedShipperOptions}
                    />
                  </Accordion>
                  <Accordion accTitle={t("LABEL_CONSIGNEE")} openAccordion={false}>
                    <DropdownSearch
                      className="w-full standard-input"
                      containerClassName="float-left width-full contents"
                      hasSearch
                      labelClassName="sm-light-tag block float-left mb-1"
                      labels={this.state.labelConsignees}
                      multiSelect
                      onLabelRemove={(value: string) => {
                        this.removeLabelConsignee(value);

                        const selectedConsignees = ArrayUtilities.removeValueFromArray(
                          filters.consignees,
                          value
                        );

                        this.props.changeConsigneeOptions(
                          this.props.consigneeOptions,
                          selectedConsignees
                        );

                        this.onFilter(
                          nameof<BookingFilters>((item) => item.consignees),
                          t("LABEL_POL"),
                          selectedConsignees.length > 0 ? selectedConsignees : null,
                          true,
                          false
                        );
                      }}
                      onSelect={(value: string) => {
                        const text = this.props.consigneeOptions.find(
                          (x) => x.value == value
                        )?.item;

                        this.addLabelConsignee({ text: text, key: value });

                        if (!filters.consignees) {
                          filters.consignees = [];
                        }
                        const selectedConsignees = ArrayUtilities.addValueToArray(
                          filters.consignees,
                          value
                        );

                        this.props.changeConsigneeOptions(
                          this.props.consigneeOptions,
                          selectedConsignees
                        );

                        this.onFilter(
                          nameof<BookingFilters>((item) => item.consignees),
                          t("LABEL_CONSIGNEE"),
                          selectedConsignees,
                          true,
                          false
                        );
                      }}
                      options={this.props.displayedConsigneeOptions}
                    />
                  </Accordion>
                  {this.state.shouldShowFreightModeFilter ? (
                    <Accordion accTitle={t("LABEL_TRANSPORT_TYPE")} openAccordion={false}>
                      <Checkbox
                        checked={filters.freightModes.includes(FreightMode.AI)}
                        className="pb-1"
                        label={t("LABEL_AIR_FREIGHT")}
                        onChange={() => {
                          this.onFilter(
                            nameof<BookingFilters>((item) => item.freightModes),
                            t("LABEL_TRANSPORT_TYPE"),
                            ArrayUtilities.toggleValueInArray(filters.freightModes, FreightMode.AI),
                            true,
                            false
                          );
                        }}
                        type="checkbox"
                      />
                      <Checkbox
                        checked={filters.freightModes.includes(FreightMode.SH)}
                        className="pb-1"
                        label={t("LABEL_SEA_FREIGHT")}
                        onChange={() => {
                          this.onFilter(
                            nameof<BookingFilters>((item) => item.freightModes),
                            t("LABEL_TRANSPORT_TYPE"),
                            ArrayUtilities.toggleValueInArray(filters.freightModes, FreightMode.SH),
                            true,
                            false
                          );
                        }}
                        type="checkbox"
                      />
                    </Accordion>
                  ) : null}

                  <Accordion accTitle={t("LABEL_FILTER_CUSTOMS")} openAccordion={false}>
                    <Checkbox
                      checked={
                        filters.isCustomsCleared === "" ||
                        typeof filters.isCustomsCleared === "undefined"
                      }
                      className="pb-1"
                      label={t("TEXT_ALL")}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.isCustomsCleared),
                          "",
                          event.target.value,
                          true,
                          false
                        );
                      }}
                      type="radio"
                      value=""
                    />
                    <Checkbox
                      checked={filters.isCustomsCleared === false}
                      className="pb-1"
                      label={t("LABEL_NO")}
                      onChange={() =>
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.isCustomsCleared),
                          t("LABEL_FILTER_CUSTOMS"),
                          false,
                          true,
                          false
                        )
                      }
                      type="radio"
                    />
                    <Checkbox
                      checked={filters.isCustomsCleared === true}
                      className="pb-1"
                      label={t("LABEL_YES")}
                      onChange={() =>
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.isCustomsCleared),
                          t("LABEL_FILTER_CUSTOMS"),
                          true,
                          true,
                          false
                        )
                      }
                      type="radio"
                    />
                  </Accordion>

                  <Accordion accTitle={t("LABEL_EXPORT_HAZ")} openAccordion={false}>
                    <Checkbox
                      checked={
                        filters.isHazardous === "" || typeof filters.isHazardous === "undefined"
                      }
                      className="pb-1"
                      label={t("TEXT_ALL")}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.isHazardous),
                          "",
                          event.target.value,
                          true,
                          false
                        );
                      }}
                      type="radio"
                      value=""
                    />
                    <Checkbox
                      checked={filters.isHazardous === false}
                      className="pb-1"
                      label={t("TEXT_NO")}
                      onChange={() =>
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.isHazardous),
                          t("LABEL_EXPORT_HAZ"),
                          false,
                          true,
                          false
                        )
                      }
                      type="radio"
                    />
                    <Checkbox
                      checked={filters.isHazardous === true}
                      className="pb-1"
                      label={t("TEXT_YES")}
                      onChange={() =>
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.isHazardous),
                          t("LABEL_EXPORT_HAZ"),
                          true,
                          true,
                          false
                        )
                      }
                      type="radio"
                    />
                  </Accordion>

                  <Accordion accTitle={t("LABEL_DELIVERY_ROUTE")} openAccordion={false}>
                    <Checkbox
                      checked={filters.transportPaths.includes(TransportPath.IMPORT)}
                      className="pb-1"
                      label={t("LABEL_IMPORT_ICELAND")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.transportPaths),
                          t("LABEL_DELIVERY_ROUTE"),
                          ArrayUtilities.toggleValueInArray(
                            filters.transportPaths,
                            TransportPath.IMPORT
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.transportPaths.includes(TransportPath.EXPORT)}
                      className="pb-1"
                      label={t("LABEL_EXPORT_ICELAND")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.transportPaths),
                          t("LABEL_DELIVERY_ROUTE"),
                          ArrayUtilities.toggleValueInArray(
                            filters.transportPaths,
                            TransportPath.EXPORT
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.transportPaths.includes(TransportPath.DOMESTIC)}
                      className="pb-1"
                      label={t("LABEL_WITHIN_ICELAND")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.transportPaths),
                          t("LABEL_DELIVERY_ROUTE"),
                          ArrayUtilities.toggleValueInArray(
                            filters.transportPaths,
                            TransportPath.DOMESTIC
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                    <Checkbox
                      checked={filters.transportPaths.includes(TransportPath.INTERNATIONAL)}
                      className="pb-1"
                      label={t("LABEL_OUTSIDE_ICELAND")}
                      onChange={() => {
                        this.onFilter(
                          nameof<BookingFilters>((item) => item.transportPaths),
                          t("LABEL_DELIVERY_ROUTE"),
                          ArrayUtilities.toggleValueInArray(
                            filters.transportPaths,
                            TransportPath.INTERNATIONAL
                          ),
                          true,
                          false
                        );
                      }}
                      type="checkbox"
                    />
                  </Accordion>
                </div>
                <div className="fixed md:absolute z-40 bottom-0 left-0 md:left-auto md:bottom-auto md:top-0 md:right-0 w-full md:w-auto listFilterLayout__filter-btn block xl:hidden md:px-5 md:py-3 leading-none">
                  <button
                    className="px-4 py-5 md:pt-3 pb-4 md:pb-2 w-full md:w-auto bg-lighter-gray uppercase focus:outline-none leading-none"
                    onClick={() => this.setState({ mobileFilter: !this.state.mobileFilter })}
                    type="button"
                  >
                    <span className="font-bold">
                      {!this.state.mobileFilter ? t("LABEL_FILTER_SEARCH") : t("LABEL_HIDE")}{" "}
                    </span>{" "}
                    {labels.length > 0 ? `(${labels.length})` : null}
                  </button>
                </div>
              </>
              {UserUtilities.userHasAccessToRoles(userProfile, [UserRole.REQUESTS]) ? (
                <ActionBar
                  haveClearedCustoms={this.selectedBookingsHaveCleared(true)}
                  haveNotClearedCustoms={this.selectedBookingsHaveCleared(false)}
                  onClickCallback={() => this.setState({ selectedBookings: [] })}
                  references={this.state.selectedBookings}
                  show={this.state.selectedBookings.length > 1}
                />
              ) : null}
            </ListFilterLayout>
          </main>
        )}
      </Translation>
    );
  }
}

export default connect(
  (state: AppState) => {
    return {
      bookingsAll: state.BookingReducer.bookingsAll,
      bookings: state.BookingReducer.bookings,
      favoriteBookings: state.BookingReducer.favoriteBookings,
      userProfile: state.UserReducer.userProfile,
      isFetchingExcelBookings: state.BookingReducer.isFetchingExcelBookings,
      loadingBookingsInit: state.BookingReducer.loadingBookingsInit,
      loadingBookings: state.BookingReducer.loadingBookings,
      shippingTypeOptions: state.BookingReducer.shippingTypeOptions,
      displayedShippingTypeOptions: state.BookingReducer.displayedShippingTypeOptions,
      polOptions: state.BookingReducer.polOptions,
      displayedPolOptions: state.BookingReducer.displayedPolOptions,
      displayedPodOptions: state.BookingReducer.displayedPodOptions,
      displayedConsigneeOptions: state.BookingReducer.displayedConsigneeOptions,
      displayedShipperOptions: state.BookingReducer.displayedShipperOptions,
      podOptions: state.BookingReducer.podOptions,
      shipperOptions: state.BookingReducer.shipperOptions,
      consigneeOptions: state.BookingReducer.consigneeOptions,
    };
  },
  {
    fetchBookingListFrontEnd,
    fetchBookingList,
    changeShippingTypeOptions,
    changePodOptions,
    changePolOptions,
    changeShipperOptions,
    changeConsigneeOptions,
    getFavoriteBookings,
    getBookingsInExcel,
    updateWebSetting,
  }
)(Shipments);
